import { ReactNode } from 'react';

export enum CTA_TOOL_VARIANT_ENUM {
  ACTION = 'ACTION',
  INFO = 'INFO',
}

export type CTAToolType = {
  key?: string;
  children: ReactNode;
  icon?: string;
  onClick?: () => void;
  href?: string;
  variant?: CTA_TOOL_VARIANT_ENUM;
};
